import { createSlice } from '@reduxjs/toolkit';
import {
  createFilledCustomFormsThunk,
  deleteFilledCustomFormsThunk,
  getFilledCustomFormsThunk,
  updateFilledCustomFormsThunk,
} from './thunks/filledCustomFormsThunks';

export const filledCustomFormsSlice = createSlice({
  name: 'filledCustomForms',
  initialState: {
    forms: {},
    filledSelectedForm: null,
    isLoading: false,
    error: null,
  },

  reducers: {
    setForms: (state, action) => {
      state.forms = action.payload;
    },
    setFilledSelectedForm: (state, action) => {
      state.filledSelectedForm = action.payload;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(getFilledCustomFormsThunk.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFilledCustomFormsThunk.fulfilled, (state, action) => {
        const filteredByTemplate = {};
        action.payload.forEach((form) => {
          if (!filteredByTemplate[form.templateId]) {
            filteredByTemplate[form.templateId] = [];
          }
          filteredByTemplate[form.templateId].push(form);
        });
        state.forms = filteredByTemplate;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getFilledCustomFormsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(createFilledCustomFormsThunk.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createFilledCustomFormsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(createFilledCustomFormsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateFilledCustomFormsThunk.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateFilledCustomFormsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        if (state.filledSelectedForm && action.payload) {
          state.filledSelectedForm = action.payload;
        }
      })
      .addCase(updateFilledCustomFormsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(deleteFilledCustomFormsThunk.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteFilledCustomFormsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        const { id, templateId } = action.payload;
        if (state.forms[templateId]) {
          state.forms[templateId] = state.forms[templateId].filter(
            (form) => form.id !== id
          );
        }
      })
      .addCase(deleteFilledCustomFormsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { setForms, getForms, setFilledSelectedForm } =
  filledCustomFormsSlice.actions;

// Selectors
export const selectAllFilledCustomForms = (state) => {
  return state.filledCustomFormsSlice?.forms;
};
export const selectCustomFormsLoading = (state) =>
  state.filledCustomFormsSlice?.isLoading;
export const selectFormsError = (state) => state.filledCustomFormsSlice?.error;
export const selectFilledSelectedForm = (state) => {
  const selectedForm = state.filledCustomFormsSlice.filledSelectedForm;
  const inputFieldArray = Object.values(selectedForm.inputFields || []);
  const sortedInputFields = [...inputFieldArray].sort((a, b) => {
    if (a.y === b.y) {
      return a.x - b.x;
    }
    return a.y - b.y;
  });
  return {
    ...selectedForm,
    inputFields: sortedInputFields,
  };
};
